module.exports = __webpack_public_path__ + "images/file_icons_v2/app-9b28d50ad530222ce74b5470c4ffe77b.svg";